export const routes = {
    landing: '/'
};
